<div class="p-4 md:p-6 max-w-4xl mx-auto" *ngIf="email">

  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">person_add</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Registro de Usuario</h1>
  </div>

  <!-- Card Datos Personales -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!isCompany">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">badge</mat-icon>
        Datos personales
      </h2>
    </div>
    <div class="p-5 md:p-8">
      <form class="space-y-4 md:space-y-5" [formGroup]="datosForm">
        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Email</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">email</mat-icon>
            <input type="email" matInput formControlName="email" placeholder="Ingresa tu correo electrónico" />
            <mat-error *ngIf="this.datosForm.get('email')!.hasError('email')">Ingresa un correo electrónico válido</mat-error>
            <mat-error *ngIf="this.datosForm.get('email')!.hasError('required')">El correo es obligatorio</mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Nombre</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">person</mat-icon>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="nombre" placeholder="Ingresa tu nombre" />
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('pattern')">Sólo caracteres alfábeticos</mat-error>
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('maxlength')">Máximo 40 caracteres</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Apellidos</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">person</mat-icon>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="apellido" placeholder="Ingresa tu apellido" />
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('pattern')">Sólo caracteres alfábeticos</mat-error>
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('maxlength')">Máximo 40 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Tipo documento</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">description</mat-icon>
            <mat-select required formControlName="tipoId">
              <mat-option>Tipo documento</mat-option>
              <mat-option *ngFor="let tipoID of tiposID" [value]="tipoID">{{ tipoID }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Numero identificación</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">fingerprint</mat-icon>
            <input (blur)="validateRut()" type="text" matInput formControlName="numeroId" placeholder="Ingresa tu documento" />
            <div *ngIf="this.datosForm.controls['numeroId'].invalid && (this.datosForm.controls['numeroId'].dirty || this.datosForm.controls['numeroId'].touched)" class="error-file alert">
              <mat-error *ngIf="this.datosForm.get('numeroId')!.errors!['incorrectFormat'] === true">Ingrese un rut válido</mat-error>
              <mat-error *ngIf="this.datosForm.get('numeroId')!.hasError('maxlength')">Máximo 15 caracteres</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Nacionalidad</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">public</mat-icon>
            <input type="text" placeholder="Selecciona un país" matInput formControlName="nacionalidad" required [matAutocomplete]="autoPaisNacionalidad" (blur)="checkPais('nacionalidad')" />
            <mat-autocomplete autoActiveFirstOption #autoPaisNacionalidad="matAutocomplete">
              <mat-option *ngFor="let pais of optionsNacionalidad | async" [value]="pais.NAME" class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field col-span-1">
            <mat-label>Código</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">phone</mat-icon>
            <input type="text" placeholder="Selecciona uno" aria-label="Number" matInput formControlName="prefijoTelefono" [matAutocomplete]="auto" (blur)="checkPrefijo()" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPrefijoTelefono | async" [value]="pais.DIAL" class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.DIAL }} - {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field col-span-2">
            <mat-label>Teléfono</mat-label>
            <input type="text" matInput appOnlynumber formControlName="telefono" placeholder="Ingresa tu Teléfono" />
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field col-span-1">
            <mat-label>Sexo</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">wc</mat-icon>
            <mat-select required formControlName="sexo">
              <mat-option>Selecciona una opción</mat-option>
              <mat-option *ngFor="let sexo of sexos" [value]="sexo" class="flex flex-row">
                <span> {{ sexo }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field col-span-2">
            <mat-label>Selecciona tu fecha</mat-label>
            <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="fechaNacimiento" />
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>País de residencia</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">place</mat-icon>
            <input type="text" placeholder="Selecciona un país" aria-label="Number" matInput formControlName="paisResidencia" [matAutocomplete]="autoPais" (blur)="checkPais('paisResidencia')" />
            <mat-autocomplete autoActiveFirstOption #autoPais="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPaisResidencia | async" [value]="pais.NAME" class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Ciudad de residencia</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">location_city</mat-icon>
            <input type="text" matInput formControlName="ciudadResidencia" placeholder="Ej. Santiago" />
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Dirección</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">home</mat-icon>
            <input type="text" matInput formControlName="direccion" placeholder="Ej. Santiago" />
            <mat-error *ngIf="this.datosForm.get('direccion')!.hasError('maxlength')">Máximo 60 caracteres</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Profesión</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">work</mat-icon>
            <input type="text" matInput formControlName="profesion" placeholder="Ej. Ingeniero" />
            <mat-error *ngIf="this.datosForm.get('profesion')!.hasError('maxlength')">Máximo 30 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <ngx-mat-file-input class="w-full" formControlName="documentoFrontal" [multiple]="false" [accept]="'image/*'" color="primary" placeholder="Adjunte imagen frontal de su documento"></ngx-mat-file-input>
            <div *ngIf="this.datosForm.controls['documentoFrontal'].invalid && (this.datosForm.controls['documentoFrontal'].dirty || this.datosForm.controls['documentoFrontal'].touched)" class="error-file alert">
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['maxSize']">Máximo 5 MB</mat-error>
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['incorrectFormat']">Únicamente formatos JPG o PNG</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <ngx-mat-file-input [multiple]="false" formControlName="documentoPosterior" [accept]="'image/*'" color="primary" placeholder="Adjunte imagen posterior de su documento"></ngx-mat-file-input>
            <div *ngIf="this.datosForm.controls['documentoPosterior'].invalid && (this.datosForm.controls['documentoPosterior'].dirty || this.datosForm.controls['documentoPosterior'].touched)" class="error-file alert">
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['maxSize']">Máximo 5 MB</mat-error>
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['incorrectFormat']">Únicamente formatos JPG o PNG</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-slide-toggle formControlName="politicamenteExpuesto">¿Es usted una persona expuesta politicamente?</mat-slide-toggle>
        </div>

        <div class="flex justify-center pt-4">
          <button type="button" (click)="enviarDatos()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 48px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">send</mat-icon>
            Enviar datos
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Card Registro Empresa -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="isCompany">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">business</mat-icon>
        Registro Empresa
      </h2>
    </div>
    <div class="p-5 md:p-8">
      <form class="space-y-4 md:space-y-5" [formGroup]="datosForm">
        <!-- Representante Legal -->
        <h3 style="font-size: 1rem; font-weight: 700; color: #1e5a3f; margin: 0 0 4px; display: flex; align-items: center; gap: 6px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">person</mat-icon>
          Representante Legal
        </h3>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Nombre</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">person</mat-icon>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="nombre" placeholder="Ingresa tu nombre" />
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('pattern')">Sólo caracteres alfábeticos</mat-error>
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('maxlength')">Máximo 40 caracteres</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Apellidos</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">person</mat-icon>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="apellido" placeholder="Ingresa tu apellido" />
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('pattern')">Sólo caracteres alfábeticos</mat-error>
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('maxlength')">Máximo 40 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Tipo documento</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">description</mat-icon>
            <mat-select required formControlName="tipoId">
              <mat-option>Tipo documento</mat-option>
              <mat-option *ngFor="let tipoID of tiposID" [value]="tipoID">{{ tipoID }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Numero identificación</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">fingerprint</mat-icon>
            <input (blur)="validateRut()" type="text" matInput formControlName="numeroId" placeholder="Ingresa tu documento" />
            <div *ngIf="this.datosForm.controls['numeroId'].invalid && (this.datosForm.controls['numeroId'].dirty || this.datosForm.controls['numeroId'].touched)" class="error-file alert">
              <mat-error *ngIf="this.datosForm.get('numeroId')!.errors!['incorrectFormat'] === true">Ingrese un rut válido</mat-error>
              <mat-error *ngIf="this.datosForm.get('numeroId')!.hasError('maxlength')">Máximo 15 caracteres</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field col-span-1">
            <mat-label>Código</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">phone</mat-icon>
            <input type="text" placeholder="Selecciona uno" aria-label="Number" matInput formControlName="prefijoTelefono" [matAutocomplete]="auto" (blur)="checkPrefijo()" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPrefijoTelefono | async" [value]="pais.DIAL" class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.DIAL }} - {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field col-span-2">
            <mat-label>Teléfono</mat-label>
            <input type="text" matInput appOnlynumber formControlName="telefono" placeholder="Ingresa tu Teléfono" />
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <ngx-mat-file-input class="w-full" formControlName="documentoFrontal" [multiple]="false" [accept]="'image/*'" color="primary" placeholder="Adjunte imagen frontal de su documento"></ngx-mat-file-input>
            <div *ngIf="this.datosForm.controls['documentoFrontal'].invalid && (this.datosForm.controls['documentoFrontal'].dirty || this.datosForm.controls['documentoFrontal'].touched)" class="error-file alert">
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['maxSize']">Máximo 5 MB</mat-error>
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['incorrectFormat']">Únicamente formatos JPG o PNG</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <ngx-mat-file-input [multiple]="false" formControlName="documentoPosterior" [accept]="'image/*'" color="primary" placeholder="Adjunte imagen posterior de su documento"></ngx-mat-file-input>
            <div *ngIf="this.datosForm.controls['documentoPosterior'].invalid && (this.datosForm.controls['documentoPosterior'].dirty || this.datosForm.controls['documentoPosterior'].touched)" class="error-file alert">
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['maxSize']">Máximo 5 MB</mat-error>
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['incorrectFormat']">Únicamente formatos JPG o PNG</mat-error>
            </div>
          </mat-form-field>
        </div>

        <!-- Empresa -->
        <h3 style="font-size: 1rem; font-weight: 700; color: #1e5a3f; margin: 16px 0 4px; display: flex; align-items: center; gap: 6px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">business</mat-icon>
          Empresa
        </h3>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Nombre o Razón Social</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">business_center</mat-icon>
            <input type="text" matInput formControlName="razonSocial" placeholder="Ingresa la razón social" />
            <mat-error *ngIf="this.datosForm.get('razonSocial')!.hasError('maxlength')">Máximo 40 caracteres</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Nombre comercial</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">storefront</mat-icon>
            <input type="text" matInput formControlName="nombreComercial" placeholder="Ingresa el nombre comercial" />
            <mat-error *ngIf="this.datosForm.get('nombreComercial')!.hasError('maxlength')">Máximo 40 caracteres</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Rut Empresa</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">fingerprint</mat-icon>
            <input (blur)="validateRutEmpresa()" type="text" matInput formControlName="rutEmpresa" placeholder="Ingresa tu documento" />
            <div *ngIf="this.datosForm.controls['rutEmpresa'].invalid && (this.datosForm.controls['rutEmpresa'].dirty || this.datosForm.controls['rutEmpresa'].touched)" class="error-file alert">
              <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.errors!['incorrectFormat'] === true">Ingrese un rut válido</mat-error>
              <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.hasError('maxlength')">Máximo 15 caracteres</mat-error>
            </div>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Domicilio fiscal</mat-label>
            <mat-icon matPrefix style="color: #9ca3af;">home</mat-icon>
            <input type="text" matInput formControlName="domicilioFiscal" placeholder="Ej. Santiago" />
            <mat-error *ngIf="this.datosForm.get('domicilioFiscal')!.hasError('maxlength')">Máximo 60 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <ngx-mat-file-input [multiple]="false" formControlName="documentoIdTributario" [accept]="'image/*, .pdf'" color="primary" placeholder="Adjunte Documento de Identificación Tributario"></ngx-mat-file-input>
            <div *ngIf="this.datosForm.controls['documentoIdTributario'].invalid && (this.datosForm.controls['documentoIdTributario'].dirty || this.datosForm.controls['documentoIdTributario'].touched)" class="error-file alert">
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoIdTributario')!.errors!['maxSize']">Máximo 5 MB</mat-error>
              <mat-error class="error-file" *ngIf="this.datosForm.get('documentoIdTributario')!.errors!['incorrectFormat']">Únicamente formatos JPG, PNG o PDF</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <ngx-mat-file-input [multiple]="false" formControlName="estatuto" [accept]="'image/*, .pdf'" color="primary" placeholder="Adjunte Estatuto constitutivo de la empresa"></ngx-mat-file-input>
            <div *ngIf="this.datosForm.controls['estatuto'].invalid && (this.datosForm.controls['estatuto'].dirty || this.datosForm.controls['estatuto'].touched)" class="error-file alert">
              <mat-error class="error-file" *ngIf="this.datosForm.get('estatuto')!.errors!['maxSize']">Máximo 5 MB</mat-error>
              <mat-error class="error-file" *ngIf="this.datosForm.get('estatuto')!.errors!['incorrectFormat']">Únicamente formatos JPG, PNG o PDF</mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="flex justify-center pt-4">
          <button type="button" (click)="enviarDatos()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 48px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">send</mat-icon>
            Enviar datos
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
